import {Component, inject, OnDestroy, OnInit, signal} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {finalize} from 'rxjs';
import {AuthService} from '../../../core/auth/auth.service';
import {ApiResponse} from '../../../shared/model/api-response';

@Component({
  selector: 'app-registration-result',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './registration-result.html',
  styleUrl: './registration-result.scss',
})
export class RegistrationResultComponent implements OnInit, OnDestroy {

  private authService: AuthService = inject(AuthService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  isLoading = signal(true);
  isSuccess = signal(false);
  message = signal('Verifica in corso...');
  private token: string | null = null;
  private redirectTimeoutId: number | null = null;

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if (!this.token) {
      this.isLoading.set(false);
      this.isSuccess.set(false);
      this.message.set('Token mancante o non valido. Controlla il link ricevuto via email.');
      return;
    }

    this.runVerification();
  }

  retryVerification(): void {
    this.clearRedirectTimeout();
    if (this.token) {
      this.runVerification();
    }
  }

  ngOnDestroy(): void {
    this.clearRedirectTimeout();
  }

  private runVerification(): void {
    if (!this.token) {
      return;
    }

    this.isLoading.set(true);
    this.message.set('Verifica in corso...');

    this.authService.verifyEmail(this.token)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (response: ApiResponse<string>) => {
          this.isSuccess.set(response.success);
          this.message.set(response.message || (response.success
            ? 'Email verificata correttamente.'
            : 'Non e stato possibile verificare la tua email.'));
          if (response.success) {
            this.scheduleRedirectToLogin();
          }
        },
        error: (error) => {
          this.isSuccess.set(false);
          this.message.set(error?.error?.message || 'Link non valido o scaduto. Richiedi una nuova registrazione.');
        }
      });
  }

  private scheduleRedirectToLogin(): void {
    this.clearRedirectTimeout();
    this.redirectTimeoutId = window.setTimeout(() => {
      this.router.navigate(['/login']);
    }, 5000);
  }

  private clearRedirectTimeout(): void {
    if (this.redirectTimeoutId !== null) {
      window.clearTimeout(this.redirectTimeoutId);
      this.redirectTimeoutId = null;
    }
  }

}
